export default __webpack_public_path__ + "static/media/ArzTrading_logo-02.d09ac8f8.svg";